import { PrimaryButton, PasswordInput } from '@artprov/design-system'
import { useNuevaContraseña } from './nueva-contrasena.hook'
import { useEffect } from 'react'

export function NuevaContrasenaSection() {
  const {
    password,
    confirmPassword,
    onPasswordChange,
    onConfirmPasswordChange,
    onSubmit,
    passwordHints,
    errors,
    disabled,
  } = useNuevaContraseña()

  const handleKeydown = (e) => {
    if (e.key === 'Enter' && !disabled) {
      onSubmit()
    }
  }

  const confirmPasswordHints = errors.confirmPassword ? [{ variant: 'error', text: errors.confirmPassword }] : []

  useEffect(() => {
    window.addEventListener('keydown', handleKeydown)
    return () => {
      window.removeEventListener('keydown', handleKeydown)
    }
  }, [disabled, onSubmit]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section className="flex flex-col gap-4 bg-tertiary-98 p-4 rounded w-full">
      <p>Escribí una nueva contraseña en el primer campo y confirmala en el segundo para continuar.</p>
      <div className="flex flex-col gap-4 bg-tertiary-100 p-6 mt-2 border border-tertiary-80 rounded-lg">
        <PasswordInput
          label="Creá tu nueva contraseña"
          placeholder="Ingresá tu nueva contraseña"
          className="w-full"
          value={password}
          isRequired
          onChange={onPasswordChange}
          hints={passwordHints}
        />
        <PasswordInput
          label="Confirmá tu nueva contraseña"
          placeholder="Volvé a escribir la contraseña"
          className="w-full"
          isRequired
          value={confirmPassword}
          onChange={onConfirmPasswordChange}
          hints={confirmPasswordHints}
          status={errors.confirmPassword ? 'error' : 'default'}
        />
        <PrimaryButton type="submit" className="w-full" disabled={disabled} onClick={onSubmit}>
          Continuar
        </PrimaryButton>
      </div>
    </section>
  )
}
